import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../../api/api';
import {
  subscribeForPush,
  unsubscribeFromPush,
} from '../../../components/special/usePushNotifications';
import Cookies from 'universal-cookie';

export const EmployeeNotificationPermission = () => {
  const { t } = useTranslation();
  const config = useConfig();
  const cookies = new Cookies();

  const [permissionStatus, setPermissionStatus] = useState(
    typeof window !== 'undefined' && 'Notification' in window
      ? Notification?.permission == 'granted'
        ? 1
        : 0
      : -1
  );

  async function handleNotificationRequest() {
    const permission = await Notification?.requestPermission();
    if (permission == 'granted') {
      const pushKey = cookies.get('pushKey');
      const res = await subscribeForPush(config, pushKey, true);

      if (res == 'success') setPermissionStatus(1);
      if (res == 'denied') setPermissionStatus(2);
      if (res == 'error') setPermissionStatus(0);
    } else {
      setPermissionStatus(2);
    }
  }

  function sendTestNotification() {
    DBRequest({
      config,
      path: 'web-push-notification-test',
      method: API_POST(),
    });
  }

  async function handleUnsubscribe() {
    await unsubscribeFromPush(config);
    setPermissionStatus(0);
  }

  return (
    <Box className="w-full flex justify-center mt-10">
      {permissionStatus === -1 ? (
        <Typography>
          {t('Your browser does not support WebPush notifications')}
        </Typography>
      ) : (
        <Box className="flex flex-col gap-5">
          {permissionStatus == 1 ? (
            <Typography>
              {t('Notification permission has been granted')}
            </Typography>
          ) : permissionStatus == 0 ? (
            <Button
              onClick={() => handleNotificationRequest()}
              className="h-10"
              variant="contained"
              color="info"
            >
              {t('Request notification permission')}
            </Button>
          ) : (
            <Typography>
              {t(
                'Notifications are disabled on your System. Please check your settings.'
              )}
            </Typography>
          )}
          <Button
            onClick={() => sendTestNotification()}
            variant="contained"
            color="info"
            disabled={permissionStatus != 1}
          >
            {t('Send test notification')}
          </Button>
          <Button
            onClick={() => handleUnsubscribe()}
            variant="contained"
            color="error"
            disabled={permissionStatus != 1}
          >
            {t('Unsubscribe from push notifications')}
          </Button>
        </Box>
      )}
    </Box>
  );
};
